import type { PreQualifyFormValues } from './types';

export const parsePreQualifyParams = (
  search: string,
): Partial<PreQualifyFormValues> => {
  const params = new URLSearchParams(search);
  return {
    firstName: params.get('firstName') ?? '',
    lastName: params.get('lastName') ?? '',
    companyName: params.get('companyName') ?? '',
    email: params.get('email') ?? '',
    phone: params.get('phone') ?? '',
    itContactEmail: params.get('itContactEmail') ?? '',
    productRequest: params.get('productRequest') ?? '',
    primaryPms: params.get('primaryPms') ?? '',
    imagingPlatform: params.get('imagingPlatform') ?? '',
  };
};

const EXPECTED_PARAMS = [
  'firstName',
  'lastName',
  'companyName',
  'email',
  'phone',
  'itContactEmail',
  'productRequest',
  'primaryPms',
  'imagingPlatform',
];

/** Returns true if any expected query params are present (even with empty values) */
export const hasValidQueryParams = (search: string): boolean => {
  const params = new URLSearchParams(search);
  return EXPECTED_PARAMS.some((key) => params.has(key));
};

/** Cloud-based PMS systems — no qualifier when paired with cloud imaging */
const CLOUD_PMS = new Set(['Denticon', 'Ascend']);

/** Cloud-based imaging systems — no qualifier when paired with cloud PMS */
const CLOUD_IMAGING = new Set(['Sota Cloud', 'ClearDent']);

/** Specific PMS + imaging pairs that should not receive the qualifier */
const EXCLUDED_PAIRS = new Set([
  'Ascend|Dentrix Ascend Imaging',
  'OpenDental|Open Dental Imaging Module',
]);

/** Download is shown for all combinations except cloud+cloud and specific excluded pairs */
export const shouldShowDownload = (values: PreQualifyFormValues): boolean => {
  const { primaryPms, imagingPlatform } = values;

  if (CLOUD_PMS.has(primaryPms) && CLOUD_IMAGING.has(imagingPlatform)) {
    return false;
  }

  if (EXCLUDED_PAIRS.has(`${primaryPms}|${imagingPlatform}`)) {
    return false;
  }

  return true;
};
